import * as React from 'react';
import * as moment from 'moment';

import Tooltip from '../Tooltip/Tooltip';

const DateTime = ({ date }) => {
  const dateObject = moment(date);
  return (
    <Tooltip text={dateObject.fromNow()}>
      {dateObject.format('DD/MM/YY [at] HH:mm')}
    </Tooltip>
  );
};

export default DateTime;
